import React, { useState, useEffect } from "react";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Grid,
  Box,
} from "@mui/material";
import { API_ADD_STUDENT, API_UPDATE_STUDENT } from "../Config/ApiUrlConstant";
import { useAuth } from "../AuthContext";
import SuccessModal from "../Common/SuccessModal";
import { ClassListArray } from "../Common/Component/CommonComponents";

const AddEditStudent = ({ studentData, onSuccess }) => {
  const { logout } = useAuth();

  const [formData, setFormData] = useState({
    class_no: "",
    student_name: "",
    student_dob: "",
    contact_no: "",
    student_uid: "",
    student_father_name: "",
    student_mother_name: "",
    student_address: "",
    father_business: "",
    session: "2025-26",
    student_photo_upload: null,
    student_uid_upload: null,
    magic_charge:0
  });

  const [message, setMessage] = useState("");
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    if (studentData) {
      setFormData({
        class_no: studentData.class || "",
        student_name: studentData.student_name || "",
        student_dob: studentData.student_dob || "",
        contact_no: studentData.contact_no || "",
        student_uid: studentData.student_uid || "",
        student_father_name: studentData.student_father_name || "",
        student_mother_name: studentData.student_mother_name || "",
        student_address: studentData.student_address || "",
        father_business: studentData.father_business || "",
        session: studentData.session || "2025-26",
        student_photo_upload: null,
        student_uid_upload: null,
        magic_charge:studentData.magic_charge || 0,
      });
    } else {
      resetForm();
    }
  }, [studentData]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const url = studentData ? API_UPDATE_STUDENT : API_ADD_STUDENT;

      const data = new FormData();
      for (const key in formData) {
        if (formData[key]) {
          data.append(key, formData[key]);
        }
      }
      if (studentData?.id) data.append("id", studentData.id);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // do NOT set Content-Type
        },
        body: data,
      });

      const responseData = await response.json();

      if (response.status === 401 || response.status === 403) {
        logout();
        return;
      }

      setMessage(
        responseData.message ||
          (studentData ? "Student updated successfully." : "Student added successfully.")
      );
      setModalVisible(true);

      if (responseData.status && onSuccess) onSuccess();
    } catch (error) {
      console.error("Error:", error);
      setMessage("Error saving student.");
      setModalVisible(true);
    }
  };

  const resetForm = () => {
    setFormData({
      class_no: "",
      student_name: "",
      student_dob: "",
      contact_no: "",
      student_uid: "",
      student_father_name: "",
      student_mother_name: "",
      student_address: "",
      father_business: "",
      session: "2025-26",
      student_photo_upload: null,
      student_uid_upload: null,
      magic_charge:0
    });
  };

  return (
    <Box sx={{ p: 1 }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* Class */}
          <Grid item xs={12} sm={6} style={{width:'120px'}}>
            <FormControl fullWidth required>
              <InputLabel>Class</InputLabel>
              <Select name="class_no" value={formData.class_no} onChange={handleChange}>
                {ClassListArray.map((cls) => (
                  <MenuItem key={cls.value} value={cls.value}>
                    {cls.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Student Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Student Name"
              name="student_name"
              value={formData.student_name}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* DOB */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="date"
              label="DOB"
              name="student_dob"
              InputLabelProps={{ shrink: true }}
              value={formData.student_dob}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Contact No */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Contact No"
              name="contact_no"
              value={formData.contact_no}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* UID */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Student UID"
              name="student_uid"
              value={formData.student_uid}
              onChange={handleChange}
            />
          </Grid>

          {/* Father's Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Father's Name"
              name="student_father_name"
              value={formData.student_father_name}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Mother's Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Mother's Name"
              name="student_mother_name"
              value={formData.student_mother_name}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Address */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              label="Address"
              name="student_address"
              value={formData.student_address}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Father's Business */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Father's Business"
              name="father_business"
              value={formData.father_business}
              onChange={handleChange}
            />
          </Grid>

          {/* File Uploads */}
          <Grid item xs={12} sm={6}>
            <Button variant="contained" component="label">
              Upload Photo
              <input
                type="file"
                name="student_photo_upload"
                hidden
                onChange={handleChange}
              />
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button variant="contained" component="label">
              Upload UID
              <input
                type="file"
                name="student_uid_upload"
                hidden
                onChange={handleChange}
              />
            </Button>
          </Grid>

          {/* Session */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Session"
              name="session"
              value={formData.session}
              InputProps={{ readOnly: true }}
              onChange={handleChange}
            />
          </Grid>

          {/* Session */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Magic Charge"
              name="magic_charge"
              value={formData.magic_charge}
              // InputProps={{ readOnly: true }}
              onChange={handleChange}
            />
          </Grid>

          {/* Submit */}
          <Grid item xs={12}>
            <Button type="submit" variant="contained">
              {studentData ? "Update Student" : "Add Student"}
            </Button>
          </Grid>
        </Grid>
      </form>

      {modalVisible && (
        <SuccessModal message={message} onClose={() => setModalVisible(false)} />
      )}
    </Box>
  );
};

export default AddEditStudent;
